import {AbstractControl} from '@angular/forms';

export function validateChargingProfileConnector(control: AbstractControl) {

    if (!control.parent) {
        return null;
    }

    const value = control.value;


    if (!value) {
        return null;
    }

    const connectorId = control.parent.get('connectorId').value;

    if (connectorId === undefined) {
        return null;
    }

    if (this.chargingProfiles.find(o => o.chargingProfilePk === value).chargingProfilePurpose === 'ChargePointMaxProfile') {
        if (connectorId !== 0) {
            return {invalidChargePointMaxProfileConnectorIdCombination: true};
        }
    }

    if (this.chargingProfiles.find(o => o.chargingProfilePk === value).chargingProfilePurpose === 'TxProfile') {
        if (connectorId === 0) {
            return {invalidTxProfileConnectorIdCombination: true};
        }
    }

    return null;
}
